import {Breadcrumb} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ItemType} from "antd/es/breadcrumb/Breadcrumb";

const AppBreadCrumb = () => {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const handleNavigation = (index: number) => {
        const pathParts = location.pathname.split('/');
        const stepBack = pathParts.length - index - 1;
        const newPath = pathParts.slice(0, -stepBack).join('/');
        navigate(newPath);
    };

    const generateItemBreadcrumb = () => {
        const items: ItemType[] = [];
        const pathParts = location.pathname.split("/");
        pathParts.map(
            (item, index) => {
                if (index > 0 && index < pathParts.length - 1) {
                    items.push({
                        key: index,
                        title: <span
                            className={'text-[0.875rem] text-blue-500 hover:text-blue-400 hover:cursor-pointer'}
                            onClick={() => handleNavigation(index)}
                        >
                            {item === "manage" ? t(`breadcrumb.home`) : t(`breadcrumb.${item}`)}
                        </span>
                    })
                }
                if (index === pathParts.length - 1) {
                    items.push({
                        key: index,
                        title: <span className={'text-[0.875rem]'}>{t(`breadcrumb.${item}`)}</span>
                    });
                }
            }
        )
        return items;
    }

    return (
        <>
            <Breadcrumb className={'my-3'} items={generateItemBreadcrumb()}/>
        </>
    );
}

export default AppBreadCrumb;